import React from 'react';
import styles from './Header.module.css';
import Logo from 'assets/images/logo.png';
import { Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useLang } from 'hooks/useLang';

const Header = () => {
  const { t } = useTranslation();
  const { lang, switchLanguage } = useLang();

  return (
    <header className={styles['header-section']}>
      <div className={styles['header-container']}>
        <div className={styles['header-content']}>
         <Link to={`/${lang}`}>
            <img src={Logo} alt="Logo" className={styles['logo-image']} />
          </Link>
          <div className={styles.controls}>
            <Link to={`/${lang}/programs#course-pricing`} className={styles.buyBtn}>
                <span id="price" className={styles.buyBtn__text}>{t('header.buyOnline')}</span>
            </Link>
            <ul className={styles.navList}>
              <li>
                <Link to={`/${lang}/programs#course-pricing`} className={styles.title}>
                  {t('header.ourPrices')}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/who-are-we`} className={styles.title}>
                  {t('header.whoWeAre')}
                </Link>
              </li>
              <li className={styles.divider}>|</li>
              <li className={styles.langs}>
                  <span className={`${styles.lang} ${lang === 'en' ? styles.active : ''}`} onClick={() => switchLanguage('en')}>Eng</span>
                  <span className={styles.langDelim}>|</span>
                  <span className={`${styles.lang} ${lang === 'ru' ? styles.active : ''}`} onClick={() => switchLanguage('ru')}>Ru</span>
              </li>
            </ul>
          </div>
        </div>
        </div>
    </header>
  );
};

export default Header;